<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <v-expand-transition>
            <v-card class="green lighten-5 pa-1" v-if="selectedBox == null">
                <Title title="環境BOXの管理">
                    <v-spacer />
                    <TitleButton
                        v-if="!isShareMode"
                        color="primary"
                        icon="mdi-radiology-box-outline"
                        name="BOX追加"
                        @click="onClickAddNewBox" />
                </Title>
                <v-container fluid class="pa-0">
                    <v-row>
                        <template v-for="box in boxes">
                            <v-col 
                                xs="12" sm="4" md="3" lg="2" xl="2" cols="12"
                                :key="box.box.boxIdentificationCode">
                                <v-card tile @click="onClickBox(box)">
                                    <div style="width:100%" class="ml-1">
                                        <table style="width:100%">
                                            <tr>
                                                <td style="width:100%; white-space:normal">                                                                    
                                                    <h4>{{box.box.name}}</h4>
                                                </td>
                                                <td v-if="canSetting(box.master)">
                                                    <v-menu offset-y>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                dark
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                color="primary"
                                                                icon>
                                                                <v-icon>mdi-menu</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <v-list dense>
                                                            <v-list-item 
                                                                v-for="menuItem in menuItems" :key="menuItem.type"
                                                                @click="onSelectedMenu(box, menuItem)">
                                                                <v-list-item-icon><v-icon>{{menuItem.icon}}</v-icon></v-list-item-icon>
                                                                <v-list-item-title>{{menuItem.text}}</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <v-divider class="mb-1" />
                                                    <h5>{{box.box.boxIdentificationCode}}</h5>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </v-card>
                            </v-col>
                        </template>
                    </v-row>
                </v-container>
            </v-card>
            <Box v-if="selectedBox != null" v-model="selectedBox" />
        </v-expand-transition>
        <MaintenanceBox ref="boxMaintenance" :boxes="boxes" />
        <Confirm ref="confirm" />
    </v-container>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    import MaintenanceBox from '@/components/box/MaintenanceBox';
    import Box from '@/components/box/Box';
    export default {
        components: {
            Title,
            TitleButton,
            Confirm,
            MaintenanceBox,
            Box
        },
        data: function () {
            return {
                /** このユーザーに登録されている全BOX */
                boxes: null,
                /** メニュー */
                menuItems: [
                    {icon: "mdi-pencil-outline", type: "edit", text: "編集"},
                    {icon: "mdi-delete", type: "delete", text: "削除"},
                ],
                /** 選択されているBOX */
                selectedBox: null
            }
        },
        computed: {
            /**
             * ユーザーUID(グループユーザーの圃場参照時は、そのユーザーのUID)
             */
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /**
             * ログインユーザーのUID
             */
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /**
             * ログインユーザーデータ
             */
            loggedInUserData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            /** 共有モード */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /** 共有モードの全種類 */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /**
             * ボックス設定を行えるか否か
             */
            canSetting: function () {
                return function (box) {
                    if (!this.isShareMode && (box.userUID == this.loggedInUserUID || this.loggedInUserData.isSystemManager)) {
                        return true
                    }
                    return false
                }
            }
        },
        created: function () {
            console.log("created")
            const self = this
            this.boxes = []
            this.$store.commit("processing", {start:true, message:"お待ち下さい…。"})
            db.collection("users").doc(this.userUID).collection("boxes").get().then(function(snapShot) {
                if (snapShot.size > 0) {
                    snapShot.forEach(function(doc) {
                        const box = doc.data()
                        db.collection("environments").doc(box.boxIdentificationCode).get().then(function(docMaster) {
                            const master = docMaster.data()
                            const boxData = {
                                box: box,
                                master: master
                            }
                            self.boxes.push(boxData)
                            if (self.boxes.length == snapShot.size) {
                                self.$store.commit("processing")
                            }
                        }).catch (function (error) {
                            self.mi_writeLog("BoxManager/created", "BOXマスターの取得に失敗しました。("+error+")")
                            self.$store.commit("processing")
                        })
                    })
                } else {
                    self.$store.commit("processing")
                }
            })
        },
        methods: {
            /**
             * BOX追加ボタン押下時
             */
            onClickAddNewBox: function () {
                this.$refs.boxMaintenance.show()
            },
            /**
             * BOXのメニュー項目選択時
             */
            onSelectedMenu: function (box, menu) {
                switch (menu.type) {
                    case "edit":
                        this.$refs.boxMaintenance.show(box)
                        break;
                }
            },
            /**
             * BOX押下時
             */
            onClickBox: function (box) {
                this.selectedBox = box
            }
        }
    }
</script>
